module.exports = __webpack_public_path__ + "img/img_qingcaoshangcheng@2x.89fd6c25.png";